import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Social from '../social'

import { Block, Title } from './components'

const Follow: React.FunctionComponent = () => {
    const { t } = useTranslation('landing')
    
    return (
        <Block>
            <Title>{t('footer.social.follow')}</Title>
            <AdjustedSocial inverted />
        </Block>
    )
}

const AdjustedSocial = styled(Social)`
    margin-left: -6px; // half of Social grid-gap
`

export default Follow